export const COMPONENT_FREQUENCIES = {
  OnlyOnce: 'OnlyOnce',
  Daily: 'DailyFrequency',
  Weekly: 'WeeklyFrequency',
  Monthly: 'MonthlyFrequency',
}
export const FREQUENCIES = {
  OnlyOnce: 'OnlyOnce',
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
}
export const DAY_TYPES = {
  Calendar: 31,
  Business: 21,
  Holiday: 20,
}
export const MONTHLY_OPTIONS = ['0', '1']
export const DAY_OPTIONS = { 1: 'first' }
export const WEEK_DAYS = {
  Sun: 'Sunday',
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
}

export const RECURRENCE_TIME_VALIDATION = [
  'OnlyOnce',
  // 'Daily',
]
